import React from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as yup from "yup";
import { Dropdown, Modal, Table } from "react-bootstrap";
import queryString from "app/services/queryStringService";
import bookingService from "app/services/AdminServices/bookingService";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import { dateTimeFormat } from "config.json";
import moment from "moment";
import { FcApproval } from "react-icons/fc";
import { TiTimes } from "react-icons/ti";
import { Formik } from "formik";
import { NotificationManager } from "react-notifications";

export default function DeclineDate({
  declineDateHandler,
  initialValues,
  validationSchema,
  declineDateShow,
  declineDateHandleCloses,
}) {
  return (
    <div>
      <Modal
        scrollable="inside"
        size="lg"
        show={declineDateShow}
        onHide={declineDateHandleCloses}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            <label className="text-dark text-bold">Date change</label>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={declineDateHandler}
            enableReinitialize={true}
          >
            {({
              values,
              errors,

              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              isValid,
              dirty,
              setFieldValue,
            }) => {
              return (
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="row">
                    <Table style={{ textAlign: "center" }}>
                      <thead></thead>
                      <tbody>
                        <tr>
                          <th>Departure Date</th>
                          <td>
                            <div className="input-group input-group-md  text-center ml-12 w-50">
                              <input
                                type="date"
                                className="form-control"
                                name="dateOfJourney"
                                value={
                                  values.changePassengerList[0].dateOfJourney
                                    ? new moment(
                                        values.changePassengerList[0].dateOfJourney
                                      ).format("YYYY-MM-DD")
                                    : ""
                                }
                                min={moment()
                                  .add(1, "days")
                                  .format("YYYY-MM-DD")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                readOnly
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    <div className="row text-center mt-2 h-100 mr-12">
                      <div className="col h-100 text-center">
                        <Button
                          variant="danger"
                          type="submit"
                          style={{ width: "20%", height: "100%" }}
                        >
                          Decline
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
}
